import React, { type FC } from "react";
import type { ValidationGroup } from "src/api/interfaces/document_validation";
import type { InboundDocument } from "src/api/interfaces/inbound_document";
import handleOverrideMetadata from "src/components/UserActions/Handlers/Validation/OverrideMetadata/override_metadata_handler";
import type { ValidationUserActionHandler } from "src/components/UserActions/Handlers/Validation/types";
import {
  type ComplianceUserActionType,
  type UserAction,
  ValidationUserActionType,
} from "src/components/UserActions/types";

export const handlersByType: Map<
  ComplianceUserActionType | ValidationUserActionType,
  ValidationUserActionHandler
> = new Map().set(
  ValidationUserActionType.OVERRIDE_METADATA,
  handleOverrideMetadata
);

export interface ValidationUserActionHandlerProps {
  readonly onCancel?: () => void;
  readonly onSubmit?: (overriddenMetadata: { [key: string]: string }) => void;
  readonly validationGroup: ValidationGroup;
  readonly userAction?: UserAction;
}

const DefaultComponent: FC<ValidationUserActionHandlerProps> = () => <></>;

export const handleValidationUserAction = async (
  inboundDocument: InboundDocument,
  action: UserAction | undefined
): Promise<FC<ValidationUserActionHandlerProps>> => {
  if (!action) return DefaultComponent;

  const handler: ValidationUserActionHandler | undefined = handlersByType.get(
    action.type
  );

  if (handler) {
    return handler(inboundDocument, action.metadata);
  }
  return DefaultComponent;
};
